"use client";

import { SimulationResult } from "./simulation-result";
import { useI18n } from "@/lib/i18n/hook";
import { SimulationProvider } from "@/components/simulation-context";
import Sidebar from "@/app/risk-simulation/sidebar";
import { Suspense } from "react";

export default function RiskSimulationPage() {
  const { t } = useI18n();

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SimulationProvider>
        <div className="flex flex-col md:flex-row flex-1">
          <Sidebar />
          <div className="md:ml-20 flex-1">
            <div className="container mx-auto px-4 py-8">
              <h1 className="text-3xl font-bold mb-6">
                {t("riskSimulation.title")}
              </h1>
              <SimulationResult />
            </div>
          </div>
        </div>
      </SimulationProvider>
    </Suspense>
  );
}
